import { createFileRoute } from '@tanstack/react-router';
import { SignalsSettingsPage } from '../../components/signals/signal-subscriptions-settings.js';

export const Route = createFileRoute('/settings/signals')({
  component: SignalsSettingsPage,
});
